import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Card, Col, Container } from 'reactstrap'
import { BackButton } from '../../components/Common/BackButton'
import Breadcrumb from '../../components/Common/Breadcrumb'
import { Expander } from '../../components/Common/Expander'
import Table1 from "../../components/Common/TableContainer"
import TableNP from "../../components/Common/TableContainerNP"
import { TableItemDeleteModal } from '../../components/Common/TableItemDeleteModal'
import { LabCitecDetailsTestEditModal } from '../LabCitec/Requests/Information/Tests/LabCitecDetailsTestEditModal'

export const LabTests = (props) => {

  const [rowInfo, setRowInfo] = useState();
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const onDelete = (values) => {
    setRowInfo(values);
    console.log('Valores delete: ', values);
    setShowModal2(true);
  }

  const onDeleteConfirmation = () => {
    console.log('Borrado confirmado:', rowInfo); // TODO: Se supone que rowInfo sólo debe ser un Id, Confirmar si si borra bien
    // dispatch(deleteLabRequestTest(rowInfo));
    setRowInfo('');
  }

  const onUpdate = (values) => {
    console.log('Valores update: ', values);
    setRowInfo(values);
    setShowModal1(true);
  }

  const columns = React.useMemo(
    () => [
      Expander,
      {
        Header: 'Norma',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Método',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.method ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Nombre del ensayo',
        width: '15%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testName ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Costos de ensayos',
        width: '14%',
        Cell: ({ row }) => (
          <div>
            <div><strong>Materiales: </strong>$ {row.original?.materials ?? '-'}</div>
            <hr className='text-success m-2' style={{ height: 3 }} />
            <div><strong>Mano de Obra: </strong>$ {row.original?.workForce ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Costos total de ensayos',
        width: '14%',
        Cell: ({ row }) => (
          <div>
            <div><strong>Costo total de ensayos: </strong>$ {row.original?.testsTotalCost ?? '-'}</div>
            <hr className='text-success m-2' style={{ height: 3 }} />
            <div><strong>Costo total de Terceros: </strong>$ {row.original?.totalThirdPartyCost ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Estatus de validación por coordinación',
        width: '8%',
        // Cell: ({ row }) => (
        //   row.original.labRequest.statusTest == 'Pendiente' ?
        //     <div className='text-warning'>Pendiente</div> :
        //     <div className='text-danger'>Estatus?</div>
        // ),
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.statusTest ?? '-'}</div> {/* TODO: Este dato viene del lugar incorrecto de postman */}
          </div>
        ),
      },
      {
        width: '6%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div>
            <div className='d-flex align-items-center justify-content-center mb-1'>
              <button className="btn btn-outline-secondary text-info d-flex justify-content-center rounded-3 p-0 px-3 m-0 w-25 " onClick={() => { onUpdate(row.original) }}> <span className="mdi mdi-18px mdi-checkbox-marked-circle"></span> </button>
            </div>
            <Link to='/addInfoToTest' className='d-flex align-items-center justify-content-center mb-1'>
              <button className="btn btn-outline-secondary text-success d-flex justify-content-center rounded-3 p-0 px-3 m-0 w-25"> <span className="mdi mdi-18px mdi-clipboard-check"></span> </button>
            </Link>
            <div className='d-flex align-items-center justify-content-center'>
              <button className="btn btn-outline-secondary text-danger d-flex justify-content-center rounded-3 p-0 px-3 m-0 w-25" onClick={() => { onDelete(row.original) }}> <span className="mdi mdi-18px mdi-delete"></span> </button>
            </div>
          </div>
        ),
      },
    ],
    []
  )

  const data = [
    {
      name: 'NMX-C-159-ONNCCE-2004',
      method: 'SGI-CITEC-SDL-ME-001',
      testName: 'MUESTREO DE AGREGADOS NMX-C-30-ONNCCE-2004',
      materials: 1500,
      workForce: 350,
      testsTotalCost: 1850,
      totalThirdPartyCost: 1550,
      statusTest: 'PENDIENTE',

      testNumber: 1,
      testDesc: 'Grava Triturada Caliza 05-10mm',
      quantity: 400,
      um: 'KG',
      testPerSample: 2,
    },
    {
      name: 'NMX-C-159-ONNCCE-2005',
      method: 'SGI-CITEC-SDL-ME-001',
      testName: 'MUESTREO DE AGREGADOS NMX-C-30-ONNCCE-2004',
      materials: 1500,
      workForce: 350,
      testsTotalCost: 1850,
      totalThirdPartyCost: 1550,
      statusTest: 'PENDIENTE',

      testNumber: 2,
      testDesc: 'Grava Triturada Caliza 05-10mm',
      quantity: 400,
      um: 'KG',
      testPerSample: 2,
    }
  ]

  const columns2 = React.useMemo(
    () => [
      {
        Header: 'No. muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testNumber ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Descripción de la muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testDesc ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Cantidad',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.quantity ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'UM',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.um ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Ensayos por muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.testPerSample ?? '-'}</div>
          </div>
        ),
      },
    ],
    []
  )

  // const renderRowSubComponent = React.useCallback(
  //   ({ row }) => (
  //       <div>
  //         <div className='text-left'>Observaciones: {row?.original?.observations ?? '-'}</div>
  //       </div>
  //   ),
  //   []
  // )

  const renderRowSubComponent = React.useCallback(
    ({ row }) => (
      // console.log('row:', row.original)
      // <div>
      //  <div className='text-left'>Observaciones: {JSON.stringify(row.original)}</div>
      // </div>

        <TableNP isAddTableBorderStrap columns={columns2} data={[row.original]} /> /* TODO: Esta "data" debe de ser la de cada renglón */
      
    ),
    []
  )

  return (
    <div className="page-content">
      <Container fluid className="" >
        <Col className="col-12" style={{ padding: 40 }}>
          <Card className='' style={{ padding: 20 }}>

            {/* TODO: Verificar el breadcrumb */}
            <Breadcrumb breadcrumbItem1='roi' breadcrumbItem2='labTests' />

            <Card className='' style={{ padding: 20 }}>

              <div className='d-flex align-items-center justify-content-between'>
                <h4 className='text-success'>ENSAYOS DE LABORATORIO | SOLICITUD DEL SERVICIO CITEC-PR-22-002</h4>
                <BackButton props={props} />
              </div>

              <hr className='text-primary mt-0' />

              <Table1 renderRowSubComponent={renderRowSubComponent} isAddTableBorderStrap columns={columns} data={data} />
              <LabCitecDetailsTestEditModal props={props} setShowModal={setShowModal1} showModal={showModal1} modalHeader='Edición de estado' />
              <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Ensayos' modalBodyLabel='¿Está seguro que desea borrar el ensayo seleccionado?' />

            </Card>

          </Card>
        </Col>
      </Container>
    </div>
  )
}
